import { render, staticRenderFns } from "./MiniKpiModule.vue?vue&type=template&id=35105526&scoped=true"
import script from "./MiniKpiModule.vue?vue&type=script&lang=js"
export * from "./MiniKpiModule.vue?vue&type=script&lang=js"
import style0 from "./MiniKpiModule.vue?vue&type=style&index=0&id=35105526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35105526",
  null
  
)

export default component.exports